import React from "react";
import { FormGroup } from "react-bootstrap";
import camera from "../../ui/templates/images.png";
import { Box } from "@material-ui/core";

class ProfileImage extends React.Component {
  myRef = React.createRef();
  focusTextInput = (e) => {
    this.myRef.current.click(e);
  };
  render() {
    const { image, handleImageChange, imageSrc } = this.props;
    return (
      <FormGroup className="container" style={{ width: "100% " }}>
        <Box
          display="flex"
          flexDirection="column"
          justifyContent="center"
          alignItems="center"
        >
          <Box className="imageProfileScreen">
            <img
              src={imageSrc || image}
              alt="Snow"
              className="circular-landscape"
            />

            <Box
              display="flex"
              justifyContent="flex-end"
              width="50%"
              alignItems="center"
              className="camera"
            >
              <img
                src={camera}
                alt=""
                onClick={this.focusTextInput}
                style={{ cursor: "pointer" }}
              />
            </Box>

            <input
              hidden
              type="file"
              accept="image/*"
              onChange={handleImageChange}
              ref={this.myRef}
            />
          </Box>
        </Box>
      </FormGroup>
    );
  }
}

export default ProfileImage;
